$(window).on('load', function(){
    $('body').removeClass('is-loading');

    setTimeout(() => {
        $('body').removeClass('loader');
    }, 1000);
});